import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  signup,
  checkEmailExists,
  checkPhoneExists,
} from "../services/authService";
import { toast } from "react-toastify";

const SignupModal = ({
  show,
  handleClose,
  openLoginModal,

  closeSignupModal,
}) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const emailInUse = await checkEmailExists(email);
      const phoneInUse = await checkPhoneExists("+91" + phone.trim());

      if (emailInUse) {
        toast.error("Email already exists! Please login.");
        return;
      }

      if (phoneInUse) {
        toast.error("Phone number already exists! Please login.");
        return;
      }

      const signupData = { name, phone: "+91" + phone.trim(), email, password };
      const response = await signup(signupData);

      toast.success("Signup Successful!");
      handleClose();
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error(typeof error === "string" ? error : "Signup failed!");
    }
  };

  const handleAlreadyHaveAccount = () => {
    closeSignupModal();
    openLoginModal();
  };

  const passwordsMatch =
    password && confirmPassword && password === confirmPassword;

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center fw-bold">SIGN UP</Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4">
        <Form onSubmit={handleSignup}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="signupName">
                <Form.Label>
                  Full Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="signupPhone">
                <Form.Label>
                  Phone Number <span className="text-danger">*</span>
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text>+91</InputGroup.Text>
                  <Form.Control
                    type="tel"
                    placeholder="Enter 10-digit phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="signupEmail">
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="signupPassword">
                <Form.Label>
                  Password <span className="text-danger">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </Button>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="signupConfirmPassword">
            <Form.Label>
              Confirm Password <span className="text-danger">*</span>
            </Form.Label>
            <InputGroup>
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Re-enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                style={{
                  borderColor:
                    confirmPassword && password
                      ? passwordsMatch
                        ? "green"
                        : "red"
                      : undefined,
                }}
              />
              <Button
                variant="outline-secondary"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </Button>
            </InputGroup>
            {confirmPassword && password && (
              <div
                style={{
                  fontSize: "0.9em",
                  marginTop: "4px",
                  color: passwordsMatch ? "green" : "red",
                }}
              >
                {passwordsMatch ? "Passwords match" : "Passwords do not match"}
              </div>
            )}
          </Form.Group>

          <Button
            type="submit"
            className="w-100 my-3"
            style={{
              backgroundColor: "#FFA500",
              borderColor: "#FFA500",
              fontWeight: "bold",
            }}
          >
            SIGN UP
          </Button>
        </Form>
      </Modal.Body>

      <div className="px-4 pb-4 text-center">
        <hr />
        <div className="fw-bold">ALREADY HAVE AN ACCOUNT?</div>
        <button
          onClick={handleAlreadyHaveAccount}
          className="btn btn-link text-decoration-none fw-bold"
          style={{ color: "#FFA500" }}
        >
          LOGIN
        </button>
      </div>
    </Modal>
  );
};

export default SignupModal;
